import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d4d1022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-detail" }
const _hoisted_2 = { class: "report-detail-wrap" }

import { reactive, ref, onMounted } from 'vue';
    import { MemberService, PhysicalService } from 'src/services';
    import pdfPreview from 'src/components/common/pdf-preview';
    import PageBack from 'src/components/common/page-back';
    import { useRouter, useRoute } from "vue-router";
    import { Toast } from "vant";
   
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    let router = useRouter();
    let route = useRoute();
    let pdfUrl = ref("");

    onMounted(()=>
    {
        let id = (route.query.id as string);

        if(id)
        {
            getphysicalDetail(id);
        }
    });

    /**
     * 获取体检任务 
     */
    let getphysicalDetail = async (id)=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getReportDetail(id);
            pdfUrl.value =  URL.createObjectURL(new Blob([res.res], { type: "application/pdf;chartset=UTF-8" }))
            // pdfUrl.value = base64ToBlob(res.data, "application/pdf;chartset=UTF-8")
        } catch (err) {
            console.log(err)
            Toast(err);
        }
    }

   

    const base64ToBlob = (base64: any, mime: any)=>{
        mime = mime || "";
        let sliceSize = 1024;
        let byteChars = window.atob(base64);
        let byteArrays = [];

        for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            let slice = byteChars.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return URL.createObjectURL(new Blob(byteArrays, { type: mime }));
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageBack)),
    _createElementVNode("div", _hoisted_2, [
      (_unref(pdfUrl))
        ? (_openBlock(), _createBlock(_unref(pdfPreview), {
            key: 0,
            url: _unref(pdfUrl)
          }, null, 8, ["url"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})